import { Endpoint } from '../endpoint';
import { ClientResponse, ClientTemplateResponse } from '@business/entities/client';
import { CompanyId } from '@business/entities/companies';

export function fetchClients(companyId: CompanyId) {
  return Endpoint.get<ClientResponse[]>(`@makh/clients`, { params: { companyId } });
}

export function createClient(client: Partial<ClientResponse>) {
  return Endpoint.post<ClientResponse>(`@makh/clients`, { data: { ...client } });
}

export function updateClientTemplate(data: ClientTemplateResponse) {
  return Endpoint.patch<ClientResponse>(`@makh/clients/client-template`, { data });
}

export function deleteClient(id: CompanyId) {
  return Endpoint.delete<void>(`@makh/clients/${id}`);
}
